import React, {useContext, useEffect, useState} from 'react';
import './AdminPanel.css'
import {deleteUser, fetchUsers} from "../../http/UserAPI";
import {Context} from "../../index";
import ModalNewUser from "../Modal/ModalNewUser";
import {useNavigate} from "react-router-dom";
import ModalDeleteUser from "../Modal/ModalDeleteUser";
import ModalOneReg from "../Modal/ModalOneReg";

const AdminPanel = () => {

    const {userStore} = useContext(Context)

    const navigate = useNavigate()

    const [allUsers, setAllUsers] = useState([])
    const [active, setActive] = useState(false)
    const [show, setShow] = useState(false)
    const [errLogin, setErrLogin] = useState(false)


    useEffect(() => {
        if (userStore.user.role !== 'ADMIN') {
            navigate('/job/task')
        }
        fetchUsers().then(data => setAllUsers(data))
    }, [])

    useEffect(() => {
        setTimeout(() => {
            fetchUsers().then(data => setAllUsers(data))
        }, 10000)
    }, [allUsers])

    const delOneUser = (id) => {
        deleteUser(id)
        fetchUsers().then(data => setAllUsers(data))
        setShow(false)
    }


    return (
        <div className="ml">
            <div className="task__name__block">
                <div className="title__task title__task_adm">Панель администратора</div>
            </div>
            <div className="input__block">
                <div className="adm__user__btn__block">
                    <div className="name__input">Пользователи</div>
                    <button className="btn__yes" onClick={() => setActive(true)}>Создать</button>
                </div>
                <div className="adm__user__list__block">
                    <div className="adm__user__list__head__block">
                        <div className="adm__user__list__head_item">Логин</div>
                        <div className="adm__user__list__head_item">Фамилия</div>
                        <div className="adm__user__list__head_item">Имя</div>
                        <div className="adm__user__list__head_item">Роль</div>
                    </div>

                    <div className="adm__user__list__date__all__block">
                        {allUsers
                            .sort(({id: previoudID}, {id: currentID}) => previoudID - currentID)
                            .map(user =>
                            <div key={user.id} className="adm__user__list__date__block">
                                <div className="adm__user__list__date__block__one">
                                    <div className="adm__user__list__date_item">{user.nickname}</div>
                                    <div className="adm__user__list__date_item">{user.firstName}</div>
                                    <div className="adm__user__list__date_item">{user.secondName}</div>
                                    {user.role === 'USER' &&
                                        <div className="adm__user__list__date_item">Пользователь</div>
                                    }
                                    {user.role === 'ADMIN' &&
                                        <div className="adm__user__list__date_item">Администратор</div>
                                    }
                                    {user.role === 'SUPERVISOR' &&
                                        <div className="adm__user__list__date_item">Руководитель</div>
                                    }
                                    {user.block &&
                                        <div className="blocked__on">Заблокирован</div>
                                    }

                                </div>
                                <div className="adm__user__list__date__block__btn">
                                    <button className="btn__user__edit" onClick={() => navigate(`/job/admin_panel/${user.id}`)}>Редактировать</button>
                                    <div className="cl-btn-6">
                                        <div className="cl-btn-6-in">
                                            <div onClick={() => setShow(true)} className="cl-btn-6-txt">Удалить</div>
                                        </div>
                                    </div>
                                    <ModalDeleteUser show={show} setShow={setShow} user={user.id} delOneUser={delOneUser}/>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
            <ModalNewUser active={active} setActive={setActive} errLogin={errLogin} setErrLogin={setErrLogin} setAllUsers={setAllUsers}/>
            <ModalOneReg errLogin={errLogin} setErrLogin={setErrLogin}/>

        </div>
    );
};

export default AdminPanel;